/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type PdpRespSimilarItem_item$ref = any;
export type PdpRespSimilarItemsGrid_similarItems$ref = any;
export type PdpRespSimilarItemsGrid_similarItems = ReadonlyArray<{
    readonly serviceId: string | null;
    readonly categoryPath: string | null;
    readonly browseUrl: string | null;
    readonly categoryCode: string | null;
    readonly title: string | null;
    readonly ecommerceTrackingParams: unknown | null;
    readonly " $fragmentRefs": PdpRespSimilarItem_item$ref;
    readonly " $refType": PdpRespSimilarItemsGrid_similarItems$ref;
}>;



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSimilarItemsGrid_similarItems",
  "type": "Item",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "serviceId",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "categoryPath",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "browseUrl",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "categoryCode",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "title",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "ecommerceTrackingParams",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItem_item",
      "args": null
    }
  ]
};
(node as any).hash = '3e38d2fe78be70542eea55c98de6aeb8';
export default node;
